module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/shopping/bitcoin-26fca6e1f79e020700d606e8a320f7d9.svg";